import React, { Component } from 'react';
import './BookSearch.css';
import { Amz } from './Amz'
import axios from 'axios';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';


function PaperComponent(props) {
  return (
    <Draggable>
    <Paper {...props} />
    </Draggable>
    );
}


class BookSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      items:[],
      bookOffset:0,
      paragraph:"",
      selectedParagraph:"",
      showModal:false,
      imageErrors: {} // Track which images failed to load
    };
  }
  async handleClickOpen(searchHit) {
    try {

      this.setState({
        selectedParagraph : searchHit
      });

      let paragraphs = await this.getParagraphs(searchHit._source.title, searchHit._source.location - 5)
      this.setState({
        paragraphs
      });
      this.setState({ open: true });

    } catch (err) {
      console.error(err)
    }

  }

  handleClose = () => {
    this.setState({
      paragraphs: null,
      showModal:false,
      selectedParagraph: null,
      open: false
    })
  };
  componentDidUpdate(prevProps) {
    if (prevProps.word !== this.props.word) {
      this.performBookSearch(this.props.word);
    }
  }
  componentDidMount() {
    this.performBookSearch(this.props.word);
  }

  async performBookSearch(word) {
    const url = this.props.baseUrl + "/search?term="+word;
    if (word.length > 0) {
      const res = await axios.get(url);
      this.setState({items:res.data.hits.hits});
      // axios.get(url)
      //   .then(res => {
      //     this.setState({items:res.data.hits.hits });
      //   })
      // fetch(url)
      //   .then(resp => resp.json())
      //   .then(data => {
      //     this.setState({items:data.hits.hits});
      //   });       
    }
  }

  /** Call the API to get current page of paragraphs */
  async getParagraphs (bookTitle, offset) {
    try {
      this.bookOffset = offset
      const start = this.bookOffset
      const end = this.bookOffset + 10
      const response = await axios.get(`${this.props.baseUrl}/paragraphs`, { params: { bookTitle, start, end } })
      this.setState({bookOffset:offset})
      return response.data.hits.hits
    } catch (err) {
      console.error(err)
    }
  }
  /** Get next page (next 10 paragraphs) of selected book */
  async nextBookPage () {
      // this.$refs.bookModal.scrollTop = 0
      const paragraphs = await this.getParagraphs(this.state.selectedParagraph._source.title, this.state.bookOffset + 10)
      this.setState({paragraphs:paragraphs});
    }
    /** Get previous page (previous 10 paragraphs) of selected book */
    async prevBookPage () {
      // this.$refs.bookModal.scrollTop = 0
      const paragraphs = await this.getParagraphs(this.state.selectedParagraph._source.title, this.state.bookOffset - 10)
      this.setState({paragraphs:paragraphs});
    }
    /** Display paragraphs from selected book in modal window */
    async showBookModal (searchHit) {
      this.setState({showModal:true})
      try {
        document.body.style.overflow = 'hidden'
        this.setState({
          selectedParagraph : searchHit
        });

        let paragraphs = await this.getParagraphs(searchHit._source.title, searchHit._source.location - 5)
        this.setState({
          paragraphs
        });
      } catch (err) {
        console.error(err)
      }
    }
    /** Close the book detail modal */
    closeBookModal () {
      document.body.style.overflow = 'auto';      
      this.setState({
        paragraphs: null,
        showModal:false,
        selectedParagraph: null
      })
    }

    getThisBook() {
      window.open(this.bookUrl(),'_blank');
      console.log(`Title: ${this.state.selectedParagraph._source.title}`);
    }

    bookUrl(key) {
      const book = Amz[key ? key : this.bookKey()];
      return book ? book['link'] : null;
      // return "https://www.amazon.com/gp/product/059035342X/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=059035342X&linkCode=as2&tag=sakunkoo05-20&linkId=237c39e78df2d66250a113ebd4879fcb";   
    }
    bookImg(item) {
      // Generate Open Library cover URL from title and author
      // Format: https://covers.openlibrary.org/b/title/{title}-M.jpg
      if (!item || !item._source) return '';
      const title = encodeURIComponent(item._source.title);
      const author = encodeURIComponent(item._source.author);
      const coverUrl = `https://covers.openlibrary.org/b/title/${title}-M.jpg?default=false`;
      return coverUrl;
    }
    bookKey(item) {
      item = item ? item : this.state.selectedParagraph;
      return `${item._source.title}-${item._source.author}`;
    }

    /** Generate a color based on the first letter of the title */
    getLetterColor(title) {
      const colors = [
        '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8',
        '#F7DC6F', '#BB8FCE', '#85C1E2', '#F8B88B', '#AAB7B8'
      ];
      const firstChar = title.charAt(0).toUpperCase();
      const index = firstChar.charCodeAt(0) % colors.length;
      return colors[index];
    }

    /** Handle image load error */
    handleImageError = (itemKey) => {
      this.setState(prevState => ({
        imageErrors: {
          ...prevState.imageErrors,
          [itemKey]: true
        }
      }));
    }
    render() {
      const listItem = this.state.items.map( (item, idx) => {
        const itemKey = this.bookKey(item);
        const hasImageError = this.state.imageErrors[itemKey];
        const firstLetter = item._source.title.charAt(0).toUpperCase();
        const backgroundColor = this.getLetterColor(item._source.title);

        return (
          <div key={idx} className="bookbox">
            <div style={{display: 'flex', flexDirection: 'column'}}>
              <div className="cover">
                {hasImageError ? (
                  <div style={{
                    width: '100px',
                    height: '150px',
                    backgroundColor: backgroundColor,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '60px',
                    fontWeight: 'bold',
                    color: 'white',
                    fontFamily: 'serif'
                  }}>
                    {firstLetter}
                  </div>
                ) : (
                  <img
                    src={this.bookImg(item)}
                    alt={item._source.title}
                    style={{maxHeight: '150px', width: 'auto'}}
                    onError={() => this.handleImageError(itemKey)}
                  />
                )}
              </div>
              <div
                className="read-button"
                style={{cursor: 'pointer'}}
                onClick={(evt) => {
                  evt.stopPropagation();
                  this.handleClickOpen(item)
                }}
              >Read</div>
            </div>
            <div className="detail">
              <div className="caption" dangerouslySetInnerHTML={{__html: item.highlight.text[0]}}></div>
              <div className="author">{(item._source.title + " - " + item._source.author)}</div>
            </div>
          </div>
        );
      });
      const paragraphs = this.state.paragraphs && this.state.selectedParagraph ? this.state.paragraphs.map( (paragraph, idx) =>
        <div key={idx}>
        { paragraph._source.location === this.state.selectedParagraph._source.location ?
          <p className="bookText">
          <strong>{paragraph._source.text}</strong>
          </p>
          :
          <p className="bookText">
          {paragraph._source.text}
          </p>


        }
        <br/>
        </div>
        ) : null;
      return (
        <div className="bookSearch">
        { this.state.showModal && this.state.selectedParagraph ?
          <div className="book-modal">
          <div className="paragraphs-container">
          <div className="title-row">
          <div className="mui--text-display2 all-caps">{this.state.selectedParagraph._source.title }</div>
          <div className="mui--text-display1">{this.state.selectedParagraph._source.author}</div>
          </div>
          <br/>
          <div className="mui-divider"></div>
          <div className="mui--text-subhead locations-label">Locations { this.state.bookOffset - 5 } to { this.state.bookOffset + 5 }</div>
          <div className="mui-divider"></div>
          <br/>

          <div>
          {paragraphs}
          <br/>

          </div>
          </div>

        {/* Book Pagination Footer */}
        <div className="modal-footer">
        <button className="mui-btn mui-btn--flat" onClick={evt => this.prevBookPage()}>Prev Page</button>
        <button className="mui-btn mui-btn--flat" onClick={(evt) => {this.closeBookModal();}}>Close</button>
        <button className="mui-btn mui-btn--flat" onClick={(evt) => this.nextBookPage()}>Next Page</button>
        </div>
        </div>
        : null }
        {this.state.open && this.state.selectedParagraph ?
          <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title"
          >
          <DialogTitle id="draggable-dialog-title">
          <div className="bookImg">
            <img
              src={this.bookImg(this.state.selectedParagraph)}
              alt={this.state.selectedParagraph._source.title}
              style={{display: 'block', margin: '0 auto', maxHeight: '200px', width: 'auto'}}
              onError={(e) => {
                // Fallback to colored letter if image fails
                const firstLetter = this.state.selectedParagraph._source.title.charAt(0).toUpperCase();
                const color = this.getLetterColor(this.state.selectedParagraph._source.title);
                e.target.outerHTML = `<div style="width: 133px; height: 200px; background-color: ${color}; display: flex; align-items: center; justify-content: center; fontSize: 80px; font-weight: bold; color: white; font-family: serif; margin: 0 auto;">${firstLetter}</div>`;
              }}
            />
          </div>

          <a href={this.bookUrl()}>
          <p className="bookDesc">{this.state.selectedParagraph._source.title } <br/>
          by<br/>
          {this.state.selectedParagraph._source.author}
          </p>
          </a>
          </DialogTitle>
          <DialogContent>

          <DialogContentText>
          {paragraphs && paragraphs.length > 0 ? paragraphs : <p>Loading content...</p>}

          </DialogContentText>
          </DialogContent>
          <DialogActions>
          <div className="modal-footer">
          {this.state.paragraphs && this.state.paragraphs.length > 9 && this.state.paragraphs[9]._source.location > this.state.selectedParagraph._source.location ?
            <Button variant="flat" onClick={evt => this.prevBookPage()}>Prev Page</Button>
            : Amz[this.bookKey()] && <Button variant="flat" onClick={evt => this.getThisBook()}>See on Amazon</Button>
          }
          <Button variant="flat" onClick={evt => this.handleClose()}>Close</Button>
          {this.state.paragraphs && this.state.paragraphs.length > 0 && this.state.paragraphs[0]._source.location < this.state.selectedParagraph._source.location ?
            <Button variant="flat" onClick={evt => this.nextBookPage()}>Next Page</Button>
            : Amz[this.bookKey()] && <Button variant="flat" onClick={evt => this.getThisBook()}>See on Amazon</Button>
          }
          </div>
          </DialogActions>
          </Dialog>
          : null }
          <span id="book-widget">{listItem}</span>
          </div>
          );
    }
  }

  export default BookSearch;
